import { combineReducers, applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk';
import logger from 'redux-logger'

import user from './Reducers/user'
//import notification from './Reducers/notification'
import generic from './Reducers/generic'
import template from './Reducers/template'

const mitarbeiter = template('mitarbeiter')
const mitarbeiterBankverbindung = template('mitarbeiterBankverbindung')
const mitarbeiterBeschaeftigung = template('mitarbeiterBeschaeftigung')
const fuhrpark = template('fuhrpark')
const kontakte = template('kontakte')
const ansprechpartner = template('ansprechpartner')
const fahrplan = template('fahrplan')
const umlaufplan = template('umlaufplan')
const kurse = template('kurse')
const dienst = template('dienst')
const dienstSingle = template('dienstSingle')
const farbzuordnung = template('farbzuordnung')
const besondererDienst = template('besondererDienst')
const parameter = template('parameter')
const zeitraum = template('zeitraum')
const verkehrshinweis = template('verkehrshinweis')
const ordner = template('ordner')
const sonderfahrt = template('sonderfahrt')
const kalender = template('kalender')
const betriebsstaetten = template('betriebsstaetten')
const abteilungen = template('abteilungen')
const funktion = template('funktion')
const leitstandSortierung = template('leitstandSortierung')
const filter = template('filter')
const dienstplanSoll = template('dienstplanSoll')
const dienstplanBusnummer = template('dienstplanBusnummer')
const zeiterfassung = template('zeiterfassung')
const users = template('users')
const me = template('me')
const sortierung = template('sortierung')
const backup = template('backup')

const store = createStore(
    combineReducers({
        me, user, users, generic, mitarbeiter, mitarbeiterBankverbindung, mitarbeiterBeschaeftigung,
        fuhrpark, kontakte, ansprechpartner, fahrplan, umlaufplan, kurse, dienst,
        farbzuordnung, besondererDienst, parameter, zeitraum, verkehrshinweis, ordner, sonderfahrt, kalender,
        betriebsstaetten, abteilungen, funktion, leitstandSortierung, filter, dienstplanSoll, dienstplanBusnummer, dienstSingle, zeiterfassung, sortierung, backup
    }),
    applyMiddleware(thunk/*, logger*/)
)
export default store



// WEBPACK FOOTER //
// ./src/Redux/index.jsx